import { createFileRoute } from "@tanstack/react-router";
import { BrandExperience } from "@/components/ui/hero/BrandExperience";
import { ProgramsCarousel } from "@/components/ui/hero/ProgramsCarousel";
import { WhyUsSection } from "@/components/sections/WhyUsSection";
import { RiskReversalCard } from "@/components/sections/pricing/RiskReversalCard";

import barberCraftImage from "@/assets/barber-craft.webp";
import justMacGarageImage from "@/assets/just-mac-garage.webp";
import mariasHouseCleaningImage from "@/assets/marias-house-cleaning.webp";
import maingearPcImage from "@/assets/maingear-pc.webp";
import healGlowWellnessImage from "@/assets/heal-glow-hero.webp";
import emotiveLogisticsImage from "@/assets/emotive-logistics.webp";
import cleanSlateJunkRemovalImage from "@/assets/cleanslate-junk-removal.webp";

const programs = [
  {
    image: barberCraftImage,
    category: "BARBERSHOP",
    title: "Barber Craft San Diego",
  },
  {
    image: justMacGarageImage,
    category: "SHOPIFY STORE",
    title: "Just Mac Garage",
  },
  {
    image: mariasHouseCleaningImage,
    category: "HOUSE CLEANING",
    title: "Marias House Cleaning",
  },
  {
    image: maingearPcImage,
    category: "GAMING PCS",
    title: "MAINGEAR Computers",
  },
  {
    image: healGlowWellnessImage,
    category: "MED SPA",
    title: "Heal + Glow Wellness",
  },
  {
    image: emotiveLogisticsImage,
    category: "EVENT LOGISTICS",
    title: "Emotive Logistics",
  },
  {
    image: cleanSlateJunkRemovalImage,
    category: "JUNK REMOVAL",
    title: "Clean Slate Junk Removal",
  },
];

export const Route = createFileRoute("/home-page-archive")({
  head: () => ({
    meta: [
      { title: "Homepage Archive — Mind Media" },
      {
        name: "description",
        content: "Internal archive of homepage sections kept for future use.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Homepage Archive — Mind Media" },
      {
        property: "og:description",
        content: "Internal archive of homepage sections kept for future use.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://mindmedia.co/home-page-archive" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      { rel: "canonical", href: "https://mindmedia.co/home-page-archive" },
    ],
  }),
  component: HomePageArchivePage,
});

function HomePageArchivePage() {
  return (
    <main className="min-h-screen bg-background">
      <div className="mx-auto max-w-7xl px-6 pt-16">
        <h1 className="text-2xl font-semibold text-foreground">Homepage Archive</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Stored for future use. This page is not indexed.
        </p>
      </div>
      {/* Archived: "Our Work" heading block that used to sit above the portfolio grid */}
      <section className="bg-background py-12">
        <div className="mx-auto max-w-7xl px-6">
          <div className="mx-auto mb-10 max-w-3xl text-center">
            <span className="inline-block rounded-full bg-brand-blue/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.12em] text-brand-blue">
              OUR WORK
            </span>
            <h2 className="mt-4 font-display text-4xl font-bold tracking-tight text-gray-950 sm:text-5xl lg:text-5xl">
              <span className="block sm:inline">Websites that</span>{" "}
              <span className="block bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-transparent sm:inline">
                deliver results.
              </span>
            </h2>
            <p className="mt-4 text-base text-gray-600 sm:text-lg">
              Every site we build is designed to be your most powerful sales tool - not just a
              pretty face.
            </p>
          </div>
        </div>
      </section>
      <BrandExperience />
      <ProgramsCarousel programs={programs} />
      {/* Archived: "Why Us" section — "What a great website actually does" */}
      <WhyUsSection />
      {/* Archived: "You See It Before You Pay Anything" risk reversal section */}
      <RiskReversalCard />
    </main>
  );
}

